import * as yup from 'yup';

import { DEFAULT_REQUIRED_FIELDS } from 'addresses/constants';
import { AddressFields } from 'addresses/enums';
import { addressSchema, contactFieldsSchema } from 'addresses/schemas';

export const upsertAddressSchema = (
  requiredFields: AddressFields[] = DEFAULT_REQUIRED_FIELDS,
  hasContactFields = false
) =>
  yup.object({
    address: addressSchema(true, requiredFields),
    ...(hasContactFields && contactFieldsSchema()),
  });
